import { Eye, EyeOff } from 'lucide-react'
import type { ComponentPropsWithoutRef } from 'react'
import { useState } from 'react'
import type { ControllerRenderProps } from 'react-hook-form'

import { Input } from '../ui/input'

interface PasswordInputProps extends ComponentPropsWithoutRef<'input'> {
  field?: Partial<ControllerRenderProps>
  showPasswordState?: boolean
}

export const PasswordInput = ({ field, showPasswordState, ...props }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(showPasswordState ?? false)
  const toggleShowPassword = () => setShowPassword(!showPassword)

  const Icon = showPassword ? EyeOff : Eye

  return (
    <div className="relative flex items-center">
      <Input
        placeholder="Insira a senha"
        type={showPassword ? 'text' : 'password'}
        {...field}
        {...props}
      />
      <Icon
        className="absolute right-3 h-5 w-5 cursor-pointer text-muted-foreground transition-colors hover:text-foreground"
        onClick={toggleShowPassword}
        aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
      />
    </div>
  )
}
